// Utils
// Types
import type { GetStaticProps, NextPage } from 'next'
// Components
import Head from 'next/head'
import type { FC } from 'react'

import PostItem from '../../components/molecules/blog/PostItem'
import ProjectHeader from '../../components/molecules/projects/ProjectHeader'
import { Post } from '../../types/hashnode'
// Content
import { getPost } from '../../utils/hashnode'

interface Props {
  contractAddress: string
  article: Post
}

const MiniDegens: FC<Props> = ({ article }) => {
  return (
    <article className="prose mx-auto max-w-2xl dark:prose-invert">
      <ProjectHeader
        title="Brain CLI"
        category="Terminal"
        logo="/images/projects/brain-cli/brain-cli.png"
        tags={['Python', 'CLI', 'AI', 'Groq', 'SQLite']}
        url="https://github.com/JairRodrigue/Brain-CLI"
      />

      <p>
        Brain CLI é um assistente de terminal com IA que transforma linguagem
        natural em comandos de Linux, Git e Docker, usando LLaMA 3 via Groq,
        memória local em SQLite e automação para executar e explicar comandos.
      </p>

      <h3>Links</h3>

      <ul>
        <li>
          <a
            href="https://github.com/JairRodrigue/Brain-CLI"
            target={'_blank'}
            rel="noopener noreferrer"
          >
            GitHub
          </a>
        </li>
        <li>
          <a
            href="https://github.com/JairRodrigue/Brain-CLI/releases"
            target={'_blank'}
            rel="noopener noreferrer"
          >
            Releases
          </a>
        </li>
      </ul>

      <h3>Leia o artigo completo</h3>

      <PostItem className="not-prose my-3" post={article} />

      <a
        className="not-prose my-4 inline-block"
        href="https://pypi.org/project/brain-cli/"
        title="View on PyPI"
        target="_blank"
        rel="noreferrer"
      >
        <div className="flex w-[220px] items-center gap-3 rounded-lg border bg-white px-4 py-3 shadow-lg">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/PyPI-Logo-notext.svg/512px-PyPI-Logo-notext.svg.png"
            alt="PyPI"
            className="size-8 object-contain"
          />

          <div className="leading-tight">
            <div className="text-xs font-medium text-gray-500">
              Disponível em
            </div>
            <div
              className="text-lg font-extrabold tracking-tight text-gray-900"
              style={{ fontFamily: '"Source Sans Pro", system-ui, sans-serif' }}
            >
              PyPI
            </div>
          </div>
        </div>
      </a>
    </article>
  )
}

const MiniDegensPage: NextPage<Props> = (props) => (
  <div className="container mx-auto">
    <Head>
      <title>Brain CLI</title>
    </Head>

    <MiniDegens {...props} />
  </div>
)

export default MiniDegensPage

export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {
      contractAddress: '0x24F6328cdDDdad9475c9a3DC2675b5ef851A7C5E',
      article: await getPost('6968db8b1065d3643b0c86fe'),
    },
  }
}
